module.exports = __webpack_public_path__ + "static/media/auth_pre.a2f08446.png";